<script setup lang="ts">
import type { CSSProperties } from 'vue'
import { computed } from 'vue'

import { normalizeTextContentToPlain } from '../../shared/textContent'

const props = defineProps<{
  content: string
  style?: CSSProperties
}>()

const text = computed(() => {
  const plain = normalizeTextContentToPlain(props.content || '')
  // Ensure trailing newlines remain measurable/visible.
  return plain.endsWith('\n') ? `${plain}\u200B` : plain
})
</script>

<template>
  <div class="pfc-text" :style="props.style">
    <div class="pfc-text__inner">{{ text }}</div>
  </div>
</template>

<style scoped>
.pfc-text__inner {
  width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
  text-align: inherit;
  text-align-last: inherit;
  text-justify: inherit;
}
</style>
